import { render, staticRenderFns } from "./TaskTypeSelect.vue?vue&type=template&id=116026d8&"
import script from "./TaskTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./TaskTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports